export default "__VITE_ASSET__73N3SRTU__"